export default {
    UPDATE_TEMTYPT(state, temType) {//更新类型
        state.temType = temType
    },
  
    

}
